import { useEffect, useRef } from "react";
import { auth } from "../data/api";

// Store switching (Header / MerchantStore) rewrites the shared `token_data` cookie with the new
// merchant_id. Cookies are shared across tabs, so a register opened in another tab is now bound to a
// STALE store: its IndexedDB catalog, taxes, and cart all belong to the old merchant. Reload so the
// register re-boots — useRegisterSync -> ensureSynced() then sees storedMerchant !== merchantId and
// full-syncs the new store, and the in-memory cart (no redux-persist) is dropped.
export function useStoreSwitchReload() {
  const bootMerchant = useRef(auth().merchantId); // merchant this tab loaded with
  useEffect(() => {
    let reloaded = false;
    const check = () => {
      if (reloaded) return;
      const current = auth().merchantId;
      // Act only on a real switch to another non-empty store. Ignore empty (logout / cookie cleared)
      // — the app's auth guards handle that, and we must not reload the register into a login loop.
      if (current && current !== bootMerchant.current) {
        reloaded = true;
        // Mark the reload as PROGRAMMATIC so the register's beforeunload guard (pending sync /
        // mid-payment) doesn't block it — a blocked reload would leave the register bound to a
        // stale store. Nothing is lost: the offline queue + recovery records live in IndexedDB and
        // are merchant-scoped; queued sales still flush after the reload.
        window.__qvProgrammaticReload = true;
        window.location.reload();
      }
    };
    const onVisible = () => {
      if (typeof document === "undefined" || !document.hidden) check();
    };
    const id = setInterval(check, 2000);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", check);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", check);
    };
  }, []);
}
